import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    minWidth: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    transition: theme.transitions.create("padding", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    flexGrow: 1,
    marginLeft: 0
  },
  rootShift: {
    transition: theme.transitions.create("padding", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    paddingLeft: theme.dimensions.drawerWidth
  },
  content: {
    height: "100%",
    minWidth: "100%",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(4)
    }
  }
}));
